module.exports = __webpack_public_path__ + "static/media/picto-blue-fast.2ef183cd.png";